import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFileContract, FaExclamationTriangle } from "react-icons/fa";
import { Card, PrimaryButton, SecondaryButton } from "../../UI/DesignStandards";

const DPAAcceptanceCard = ({ organizationId }) => {
  const navigate = useNavigate();
  return (
    <Card
      className="border-l-4 border-l-brand-charcoal"
      role="alert"
      aria-labelledby="dpa-card-title"
      aria-describedby="dpa-card-description"
    >
      <div className="p-6">
        <div className="flex items-start">
          <div className="flex-shrink-0" aria-hidden="true">
            <FaExclamationTriangle className="h-6 w-6 text-brand-muted" />
          </div>
          <div className="ml-4 flex-1">
            <h3
              id="dpa-card-title"
              className="heading-display text-lg mb-2"
            >
              Data Processing Agreement Required
            </h3>
            <p
              id="dpa-card-description"
              className="text-sm text-brand-muted mb-4"
            >
              As an organization owner or admin, you can accept the Data
              Processing Agreement (DPA) on behalf of your organization. This
              agreement outlines your responsibilities as a Data Controller.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <PrimaryButton
                icon={FaFileContract}
                className="w-full sm:w-auto"
                onClick={() => navigate("/organization/dpa-acceptance")}
                aria-label="Review and accept the Data Processing Agreement"
              >
                Review & Accept DPA
              </PrimaryButton>
              <SecondaryButton
                className="w-full sm:w-auto !px-3 !py-2 text-sm"
                onClick={() =>
                  window.open(
                    "/data-processing-agreement",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                aria-label="View Data Processing Agreement document in new window"
              >
                View DPA Document
              </SecondaryButton>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DPAAcceptanceCard;
